export default "__VITE_ASSET__e1376d2a__"